(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.blogpostpage = {
    attach: function (context, settings) {
      $(window).on('load', function () {
        $(once('blogpostpage', '.blog-post-page')).each(function () {
          // Determine which share button to show.
          Drupal.behaviors.blogpostpage.displayShareButton();

          // Schedule timer to check for resizes.
          Drupal.behaviors.blogpostpage.setupResizeTimer();

          // Show addtoany component.
          $('.addtoany_list').toggleClass('share-hidden');
        });
      });
    },
    isDesktop: function () {
      return ($('body').width() >= 1025);
    },
    displayShareButton: function () {
      if (Drupal.behaviors.blogpostpage.isDesktop()) {
        // No share buttons.
        $('.addtoany_share_native').addClass('share-hidden');
        $('.addtoany_share').addClass('share-hidden');
      }
      else if (navigator.share) {
        // Show native share button for mobile.
        $('.addtoany_share_native').removeClass('share-hidden');
        $('.addtoany_share').addClass('share-hidden');
      }
      else {
        // Show addtoany share button for mobile.
        $('.addtoany_share_native').addClass('share-hidden');
        $('.addtoany_share').removeClass('share-hidden');
      }
    },
    setupResizeTimer: function () {
      var $window = $(window);
      var $width = $window.width();
      var $height = $window.height();

      setInterval(function () {
        if (($width !== $window.width()) || ($height !== $window.height())) {
          $width = $window.width();
          $height = $window.height();

          // Determine which share button to show.
          $('.blog-post-page').each(function () {
            Drupal.behaviors.blogpostpage.displayShareButton();
          });
        }
      }, 1000);
    }
  };
})(jQuery, Drupal, once);
